import React from "react";

import background from '@cover/weiterstreiten/background-1.jpg';
import backgroundSm from '@cover/weiterstreiten/background-1-sm.jpg';
import WeiterStreiten from "../components/cover/animations/weiterstreiten";

import articleSrc from '@assets/article.svg';

export const meta = {
	category: "continue",
	slug: "streiten",
	id: "WeiterStreiten",
	excerpt: {
		before: "Seit zwei Jahren trainiert Joanna Fulde mit Berufseinsteigerinnen und -einsteigern Demokratie. Das Training ist ein Teil des Stiftungsprogramms ",
		italic: "Läuft bei dir! ",
		after: "Werte.Wissen.Weiterkommen."
	},
	name: "weiterstreiten",
	title: "Ein Quadratmeter Politik",
	animation: WeiterStreiten,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		alt: "Joanna Fulde, Demokratie-Trainerin im Programm 'Läuft bei Dir!', lächelt. Um sie herum steht mit Hand geschrieben: 'Kenne deine Werte, Vorstellungen und Bedürfnisse! Was sind deine Träume, deine Ziele, deine Wünsche?'"
	}
}

const WeiterstreitenArticle = () => {
	return (
		<div>
			<p className="articleParagraph">
				Seit zwei Jahren trainiert Joanna Fulde mit Berufseinsteigerinnen und -einsteigern in Berufsschulen Demokratie. Das Training ist ein Teil des Stiftungsprogramms <i>Läuft bei Dir!</i> Werte.Wissen.Weiterkommen, zu dem außerdem das Lerntagebuch Du bist dran!, der Escape Room Hacker Attack sowie Fortbildungsangebote für Fachkräfte gehören. 
			</p>
			<p className="articleQuestion">
				Warum brauchen Jugendliche ein Demokratietraining? Man könnte doch meinen, dass sie das im Politikunterricht gelernt haben.
			</p>
			<p className="articleAnswer">
				<i>Joanna Fulde</i>: Unser Training setzt nicht am klassischen Politikunterricht an, wo eher Wissen vermittelt wird. Bei <i>Läuft bei Dir!</i> geht es um Wertebildung durch eigenes Aktivwerden, durch Ausprobieren, durch Erlebnisse. Wir möchten mit dem Training Kompetenzen stärken, die in einer Demokratie wichtig sind. 
			</p>
			<p className="articleQuestion">
				Und warum sprechen Sie ausgerechnet Berufseinsteigerinnen und -einsteiger an? 
			</p>
			<p className="articleAnswer">
				Vor dem Eintritt in das berufliche und gesellschaftliche Leben sind die jungen Erwachsenen mit vielen Herausforderungen konfrontiert. Teilweise sind sie sehr unsicher, was ihre eigenen Wertvorstellungen angeht, ihre Wünsche und Ziele für die Zukunft. Manchmal sind sie auch einfach frustriert über die aktuelle persönliche Situation, zum Beispiel einen Ausbildungsberuf zu finden. Dazu kommt das Gefühl, dass Politik und Demokratie nicht viel mit ihnen zu tun haben und sie die gar nicht mitgestalten können.
			</p>
			<p className="articleQuestion">
				Die Jugendlichen haben also oft das Gefühl, dass sie politisch gar nichts verändern können?
			</p>
			<p className="articleAnswer">
				Genau. Wenn wir sie nach ihren Assoziationen oder Ideen zu Demokratie oder Politik fragen, fallen oft Begriffe wie „Wahlen“, „Bundestag“ oder die Namen von Politikerinnen und Politikern. Demokratie wird oft als etwas nicht Greifbares verstanden, als etwas, das mit der eigenen Lebenswelt nichts zu tun hat. Und weil die Jugendlichen Demokratie sozusagen als abgetrennt erleben, glauben sie nicht daran, Einfluss nehmen zu können.
			</p>
			<p className="articleQuestion">
				Wie schaffen Sie es, diese Lücke zu schließen?
			</p>
			<p className="articleAnswer">
				Erst einmal geht es im Training darum, dass sich die Jugendlichen bewusst über ihre eigenen Werte, Vorstellungen und Bedürfnisse werden. Wie komme ich zu einer Meinung? Wie begründe ich meinen Standpunkt und wie verteidige ich ihn? Was sind meine Träume, meine Ziele, meine Wünsche? Eine eigene Position zu beziehen ist ein zentrales Thema, das wir durch ganz verschiedene Methoden zu erreichen versuchen.
			</p>
			<p className="articleQuestion">
				Haben Sie dafür ein konkretes Beispiel?
			</p>
			<p className="articleAnswer">
				Meine Lieblingsmethode ist die „Ein-Quadratmeter-Methode“, für die wir uns viel Zeit nehmen. Dabei nutzen die Jugendlichen öffentlichen Raum. Wir gehen mit ihnen zum Beispiel auf einen Marktplatz und kleben mit Kreppband einen Quadratmeter ab. Auf dieser Fläche bieten die Jugendlichen dann etwas an, was sie mit der Gesellschaft teilen und ihr mitgeben möchten. Das können Plakate sein, auf denen Veränderungswünsche für ihre Stadt stehen oder ein Tisch, auf denen selbstgemachte Bastelarbeiten präsentiert werden. Wir hatten auch Jugendliche, die etwas aus ihrer Heimat gekocht haben. Die jungen Erwachsenen sind vollkommen frei in ihrer Kreativität. Sie können sagen, was ihnen wichtig ist, können zeigen, was sie gut können und werden ein bisschen herausgefordert, ihre Komfortzone zu verlassen. Es ist immer schön zu erleben, wie stolz und glücklich es die Jugendlichen macht, wenn sie merken, dass sie mit ihrer Persönlichkeit und ihrem Thema bei Passantinnen und Passanten etwas auslösen und bewirken.
			</p>
			<p className="articleQuestion">
				So eine Aktion erfordert sicher auch Mut.
			</p>
			<p className="articleAnswer">
				Ja. Es ist schon ungewohnt, aus der eigenen Komfortzone herauszutreten. Und es braucht Mut, sich andere Meinungen anzuhören, diese auch zu akzeptieren. Einige Jugendliche sind frustriert oder haben Diskriminierungserfahrungen gemacht und es kostet sie besondere Überwindung, sich mit ihren Wünschen zu zeigen und auf Andere zuzugehen. Das Demokratietraining bereitet sie gut auf solche Situationen vor und die positiven Erlebnisse stärken ihr Selbstvertrauen. Sie sollen merken, dass jede und jeder ein wichtiger Teil der Gesellschaft ist. 
			</p>
			<p className="articleQuestion">
				Das Demokratietraining gibt es neuerdings auch für Lehrerinnen und Lehrer sowie Schulsozialarbeiterinnen und -arbeiter. Warum brauchen die das Training?
			</p>
			<p className="articleAnswer">
				Brauchen ist vielleicht das falsche Wort. Die Fachkräfte an den Schulen sind ja die Expertinnen und Experten. Aber mit unserem speziellen Angebot können wir sie gezielt in ihrem Berufsalltag unterstützen. Die Materialien und Methoden, die es zum Beispiel für den Politikunterricht gibt, sind oft sehr theoretisch und textlastig. Vor allem eignen sie sich nicht für junge Leute in berufsvorbereitenden Maßnahmen, die die deutsche Sprache teilweise erst lernen. Deswegen ist es gut und sinnvoll, dass die Fachkräfte didaktische Zugänge aus dem Projekt <i>Läuft bei Dir!</i> an die Hand bekommen und in ihren Unterricht einbauen können. 
			</p>
			<p className="articleQuestion">
				Was haben Sie für sich aus den Trainings mit den Jugendlichen mitgenommen?
			</p>
			<p className="articleAnswer">
				Tatsächlich viele Dinge, die ich selber vermittelt habe. Wenn wir uns trauen, unsere Meinung auszudrücken, bewirken wir oft mehr, als uns bewusst ist. Ich habe auch gelernt, dass es sich lohnt, sich für die Erfahrungen und Geschichten Anderer Zeit zu nehmen. Und dass demokratische Prozesse im Kleinen stattfinden und gar nicht unbedingt in der großen Theorie liegen, wie ich es selbst aus dem Studium kenne.
			</p>
			<a href="https://www.läuft-bei-dir.de" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					Läuft bei Dir! Werte. Wissen. Weiterkommen.
					<div className="articleLinkSource">
					läuft-bei-dir.de
					</div>
				</div>
			</a>
			<a href="https://www.lpb-bw.de/fileadmin/lpb_hauptportal/pdf/publikationen/lerntagebuch_laeuft_bei_dir_2aufl.pdf" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					Das Lern-Tagebuch „Du bist dran!
					<div className="articleLinkSource">
					PDF lpb-bw.de
					</div>
				</div>
			</a>
		</div>
	)
};

export default WeiterstreitenArticle;